<tam-dialog (mousedown)="onClickSetEventValue($event)" (click)="onClickSetEventValue($event)" tid="entity_dialog"
    class="entity-dialog tag-input-text-override entity-sidesheet-status threaddetail-sidesheet-status"
    [opened]="opened" [dialogWidth]="dialogWidth" [titleName]="titleName" (keydown.esc)="onEnter($event)"
    (keyup)="keySend($event)" (containerEvent)="onContainerEvent($event)">
    <ng-template #title>
        <span class="dialog-title">{{titleName}}</span>
        <!-- <smart-icon class="dialog-min" name="substract" (click)="windowMinimize()"></smart-icon> -->
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)"
            [hidden]="isOfficeAddinMode || uploadEditing>0">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer" [ngClass]="{'is-add-in': isOfficeAddinMode}">
            <div class="flex-box">
                <div class="pull-left">
                    <span class="entity-type-label">Entity Type</span>
                    <kendo-dropdownlist [popupSettings]="{appendTo: viewContainer}" #dropDownEl [data]="entityTypes"
                        [(ngModel)]=" entityTypeCurrent" [textField]="'name'" class="entity-type" [valueField]="'id'"
                        [filterable]="true" (selectionChange)="selectionChange($event)" [disabled]="entityTypeDisabled"
                        (filterChange)="handleFilter($event)" (focus)="dropDownEl.toggle(true)"
                        (mousedown)="$event.preventDefault()">
                    </kendo-dropdownlist>
                </div>
            </div>
            <div class="pull-left" *ngIf="noEntityType">
                <span class="entity-type-label" [style.visibility]="'hidden'">Entity Type</span>
                <span class="no-template-tip">Please select an entity type</span>
            </div>
            <div *ngIf="isNeedReload"><label class="template-change">Template configuration has been updated by other
                    user, save directly might
                    cause data lost,
                    please <span class="template-reload" (click)="onClickReload()">reload.</span></label></div>
            <div class="item-tabs">
                <tabs [options]="tabsOptions" [underlineStyle]="true" tid="entity_tabs" *ngIf="isShow">
                    <ng-template let-value="data">
                        <div class="tml-tpl-row" [style.display]="(value===0)?'block':'none'" tid="overview">
                            <div class=" form-group">
                                <div class="template-container" tid="entity-dialog">
                                    <tam-template [config]="_tplConfig" (publishEvent)="publish()"
                                        [valueChangeSubject]="valueChangeSubject" [noteBodySubject]="_noteBodySubject">
                                    </tam-template>
                                </div>
                            </div>
                        </div>
                        <div class="tml-tpl-row privacy" [hidden]="value!=1">
                            <div *ngIf="entityTypeCurrent&&entityTypeCurrent.name != 'Team'" tid="privacy">
                                <div class="dual-list-label">
                                    <label class="checkbox-label">Private entity</label>
                                </div>
                                <div class="tml-tpl-input checkbox">
                                    <kendo-switch [disabled]='isDisabled' onLabel="Yes" offLabel="No"
                                        [(ngModel)]="isPrivate" (valueChange)="changePrivateStatus($event)">
                                    </kendo-switch>
                                </div>
                            </div>
                            <div *ngIf="entityTypeCurrent&&entityTypeCurrent.name == 'Team'" tid="Team">
                                <label tam-checkbox [disabled]='isDisabled' [(ngModel)]="isPrivate"><span>Private team
                                        (Team
                                        is only
                                        visible to
                                        its
                                        members)</span></label>
                            </div>
                            <div style="height: 400px;">
                                <tam-dual-list #dualList [config]="duallistConfig" [itemRender]="render"
                                    *ngIf='entityTypeCurrent&&entityTypeCurrent.name == "Team"?true:isPrivate'>
                                    <ng-template #render let-item>
                                        <div class="my-item">
                                            <span
                                                [style.font-weight]="item.data.type === 'team' ? 'bold' : 'normal'">{{item.data.name}}</span>
                                        </div>
                                    </ng-template>
                                </tam-dual-list>
                            </div>
                        </div>
                        <div [hidden]="value!=2" tid="corpdetails">
                            <div id="entityForm-tab-corpdetails" class="tab-pane tml-tpl-row"
                                *ngIf="entityTypeCurrent&&entityTypeCurrent.name == 'Corporate'">
                                <div class="panel-body">
                                    <div class="form-group">
                                        <label class="col-sm-2 control-label">Phone:</label>
                                        <div class="col-sm-10">
                                            <input tid="input_phone" class="tam-input form-control" type="text"
                                                placeholder="Phone" [(ngModel)]="entity.detail.phone" />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 control-label">Fax:</label>
                                        <div class="col-sm-10">
                                            <input tid="input_fax" class="tam-input form-control" type="text"
                                                placeholder="Fax" [(ngModel)]="entity.detail.fax" />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 control-label">Email:</label>
                                        <div class="col-sm-10">
                                            <input tid="input_email" class="tam-input form-control" type="email"
                                                name="email" placeholder="Email" [(ngModel)]="entity.detail.email"
                                                data-error="The email address is invalid" />
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 control-label">Employees:</label>
                                        <div class="col-sm-10">
                                            <input tid="input_employees" class="tam-input form-control  flex-item"
                                                type="text" placeholder="Employees"
                                                [(ngModel)]="entity.detail.numberOfEmployees" />
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="col-sm-2 control-label">Officers:</label>
                                        <div class="col-sm-10">
                                            <div class="entity-label">
                                                <div class="entity-table-header" tid="input_officers">
                                                    <label class="office-name">Name</label>
                                                    <label class="office-position">Position</label>
                                                    <label class="office-age">Age</label>
                                                    <label class="office-icon"></label>
                                                </div>

                                                <div>
                                                    <hr class="table-divider" />
                                                </div>

                                                <div *ngFor="let officer of entity.detail.officers; let i = index; trackBy: trackByFn"
                                                    class="entity-table officer-display">
                                                    <label class="office-name">{{ officer.name }}</label>
                                                    <label class="office-position">{{ officer.position }}</label>
                                                    <label class="office-age">{{ officer.age }}</label>
                                                    <div class="office-icon">
                                                        <smart-icon name="trash" class="file-action"
                                                            (click)="onClickRemoveOfficer(officer)"></smart-icon>
                                                    </div>
                                                </div>

                                                <div class="entity-table input-group officer-input">
                                                    <input type="text" class="tam-input office-name" placeholder="Name"
                                                        [(ngModel)]="name" />
                                                    <input type="text" class="tam-input office-position"
                                                        placeholder="Position" [(ngModel)]="position" />
                                                    <input type="text" class="tam-input office-age" placeholder="Age"
                                                        [(ngModel)]="age" />
                                                    <div class="office-icon">
                                                        <button tam-button [tamType]="'primary'" [disabled]="!name"
                                                            (click)="clickAddOfficers()">Add</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tml-tpl-row" tid="extrainfo"
                            [hidden]="(entityTypeCurrent&&entityTypeCurrent.name == 'Corporate')&&(value!=3) ||((value!=2) && (entityTypeCurrent&&entityTypeCurrent.name != 'Corporate'))">
                            <div class="item-alias">
                                <div class="form-group">
                                    <label class="item-label col-sm-2">Aliases:</label>
                                    <div class="col-sm-10">
                                        <tag-input tabindex="5" tid="entity_alias_input"
                                            class="form-control-alias item-value item-alias item-tag-input"
                                            theme="foundation-theme" [(ngModel)]="aliasArray" [addOnBlur]='true'
                                            [secondaryPlaceholder]="'Use \'Enter\' to input multiple values'"
                                            [placeholder]="''" [validators]="validators"
                                            [errorMessages]="errorMessages">
                                        </tag-input>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">Links:</label>
                                <div class="col-sm-10">
                                    <div>
                                        <div class="link-wrapper">
                                            <div class="entity-table-header">
                                                <label class="link-title">Title</label>
                                                <label class="link-url">URL</label>
                                                <label class="link-icon"></label>
                                            </div>
                                            <div>
                                                <hr class="table-divider" />
                                            </div>
                                            <div class="entity-table link-display"
                                                *ngFor=" let weblink of entity.webLinks;let i = index;trackBy:trackByFn">
                                                <label class="link-title">{{weblink.title}}</label>
                                                <label class="link-url">{{weblink.url}}</label>
                                                <div class="link-icon">
                                                    <smart-icon *ngIf="true" name="trash" class="file-action"
                                                        (click)="onClickRemoveLinks(weblink)">
                                                    </smart-icon>

                                                </div>
                                            </div>
                                            <div class="entity-table input-group link-input">
                                                <input type="text" class="tam-input link-title right-radius"
                                                    placeholder="Title" [(ngModel)]="weblinkName" />
                                                <input type="text" class="tam-input link-url left-radius"
                                                    placeholder="Url" [(ngModel)]="weblinkUrl" />
                                                <div class="link-icon ">
                                                    <button tam-button [tamType]="'primary'" tamSize="normal"
                                                        [disabled]="!(weblinkName&&weblinkUrl)"
                                                        class="dialog-button button-add "
                                                        (click)="clickAddWebLinks()">Add</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- address part-->
                            <div class="form-group">
                                <label class="item-label col-sm-2">Primary Address:</label>
                                <div class="col-sm-10">
                                    <tam-entity-address [(address)]="entity.webAddress[0]"
                                        [dialogOpenOptions]="dialogOpenOptions">
                                    </tam-entity-address>
                                </div>
                            </div>

                            <div *ngFor="let item of entity.webAddress;let i = index;trackBy:trackByFn">
                                <div *ngIf="i>0" class="form-group">
                                    <label class="item-label col-sm-2">Other Address {{i}}:</label>
                                    <div class="col-sm-9-address">
                                        <tam-entity-address class="col-address-form" [(address)]="entity.webAddress[i]"
                                            [dialogOpenOptions]="dialogOpenOptions">
                                        </tam-entity-address>
                                        <smart-icon name="trash" class="trash-address"
                                            (click)="onClickRemoveAddress(item)"></smart-icon>
                                    </div>
                                </div>
                            </div>
                            <label class="color-link hover-link" (click)="clickAddAddress()">Add other address</label>
                        </div>
                    </ng-template>
                </tabs>
            </div>
            <input tabindex="-1" id="hidden-entity-dialog" class="hidden-input" value={{dialogWidth}} />
            <input tabindex="-1" id="hidden-entity-dialog-open-status" class="hidden-input"
                value={{isDialogClosedForPlugin}} />
        </div>
    </ng-template>
    <ng-template #footer>
        <button tid="cancel_newEntity" tam-button tamType="tertiary" tamSize="normal"
            class="dialog-button dialog-cancel footer-research-button"
            (click)="onCancelBtnClick($event)">Cancel</button>
        <button tid="save_newEntity" tam-button tamType="primary" tamSize="normal"
            class="dialog-button dialog-publish footer-research-button" (click)="onClickSaveEntity($event)"
            [tamLoading]="isProgressing" [disabled]="noEntityType||isProgressing">Save</button>
    </ng-template>

</tam-dialog>
<ng-template #flyContainer></ng-template>